import { authApi, hasSessionAuthMarker } from '@/services/api'

type SessionIdentity = {
  displayName: string
  userId: string
}

export type SessionResumeResult =
  | { status: 'authenticated'; identity: SessionIdentity }
  | { status: 'unauthorized' | 'unavailable' | 'skipped' }

const resolveErrorStatus = (error: unknown) => (
  typeof error === 'object' && error !== null && 'status' in error
    ? Number(error.status)
    : 0
)

/** Normalize session verification so transient provider failures never become logout truth. */
export async function revalidateCaigouChinaSession(): Promise<SessionResumeResult> {
  if (!hasSessionAuthMarker()) {
    return { status: 'skipped' }
  }

  try {
    const result = await authApi.getSession()
    const userId = typeof result.user_id === 'string' ? result.user_id.trim() : ''
    const displayName = typeof result.display_name === 'string' ? result.display_name.trim() : ''
    return {
      status: 'authenticated',
      identity: { displayName, userId },
    }
  } catch (error) {
    const status = resolveErrorStatus(error)
    return status === 401 || status === 403
      ? { status: 'unauthorized' }
      : { status: 'unavailable' }
  }
}
